import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './WhyChooseUs.css';

const features = [
  {
    title: 'Fastest Delivery',
    text:
      'Retail food delivery is a courier service in which a restaurant, store, or independent food delivery company.',
  },
  {
    title: 'Deliver Support Parcel 24/7',
    text:
      'Retail food delivery is a courier service in which a restaurant, store, or independent food delivery company.',
  },
  {
    title: 'Live Order Tracking',
    text:
      'Retail food delivery is a courier service in which a restaurant, store, or independent food delivery company.',
  },
  {
    title: 'High Quality',
    text:
      'Retail food delivery is a courier service in which a restaurant, store, or independent food delivery company.',
  },
];

function WhyChooseUs() {
  useStyles(s);

  return (
    <section id="why" className={s.why}>
      <div className={s.inner}>
        <h2 className={s.heading}>
          Why Choose us Food Mall offers just for you?
        </h2>
        <div className={s.content}>
          <div className={s.left}>
            <img
              src="https://picsum.photos/seed/asap-why/840/840"
              alt="Why choose us"
            />
          </div>
          <div className={s.list}>
            {features.map(f => (
              <div key={f.title} className={s.feature}>
                <h3 className={s.featureTitle}>{f.title}</h3>
                <p className={s.featureText}>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
